const hemData = [
  {
    dependant: 0,
    single: 0,
    joint: 0,
  },
  {
    dependant: 1,
    single: 504,
    joint: 463,
  },
  {
    dependant: 2,
    single: 989,
    joint: 774,
  },
  {
    dependant: 3,
    single: 1547,
    joint: 1135,
  },
  {
    dependant: 4,
    single: 2033,
    joint: 1365,
  },
  {
    dependant: 5,
    single: 2519,
    joint: 1595,
  },
  {
    dependant: 6,
    single: 3005,
    joint: 1825,
  },
  {
    dependant: 7,
    single: 3491,
    joint: 2055,
  },
  {
    dependant: 8,
    single: 3977,
    joint: 2285,
  },
  {
    dependant: 9,
    single: 4463,
    joint: 2515,
  },
  {
    dependant: 10,
    single: 4949,
    joint: 2745,
  },
];

const HemDependant = (numberOfApplicants, numberOfDependant) => {
  const dataIndex = hemData.findIndex(
    (p) => p.dependant === Number(numberOfDependant)
  );

  switch (Number(numberOfApplicants)) {
    case 1:
      return hemData[dataIndex].single;
    case 2:
      return hemData[dataIndex].joint;
    default:
      return hemData[dataIndex].single;
  }
};

export default HemDependant;
